<template>
  <el-table-column :label="label" :prop="prop" class-name="seats" :sortable="sortable">
    <template slot-scope="scope">
      {{scope.row.seats.toLocaleString()}}
    </template>
  </el-table-column>
</template>

<script>
export default {
  components: {
  },
  props: {
    label: {
      type: String,
      default: '座席数'
    },
    prop: {
      type: String,
      default: 'seats'
    },
    sortable: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.el-table {
  th,
  td {
    &.seats {
      width: 8em;
    }
  }
}
</style>
